import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import ErrorHeader from './css';

const NoDataDecorator = ({ data, component: Component, ...rest }) => {
  if (!data) return null;

  if (!data.length) {
    return (
      <ErrorHeader>
        {t('NoResults')}
      </ErrorHeader>
    );
  }

  return (
    <Component data={data} {...rest} />
  );
};

NoDataDecorator.propTypes = {
  data: PropTypes.array,
  component: PropTypes.elementType,
};

export default NoDataDecorator;
